import './SiteLocaleSelectionPopupMenu.scss';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '../Primitives';
import { Link } from 'gatsby';
import { faCanadianMapleLeaf } from '@fortawesome/free-brands-svg-icons';
import { useCookies } from 'react-cookie';
import { useCustomerAccount } from '../../context/customerAccount/useCustomerAccount';
import {
    useGlobalLocalization,
    usePageLocalization,
} from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useCookiesConsent } from '@sbi-international/boutik.package.cookie.consent';

SiteLocaleSelectionPopupMenu.defaultProps = {
    direction: 'down',
};

// todo get it from useSiteLocale
function SiteLocaleSelectionList({
    showCurrency,
    userStore,
    pathname,
}: {
    showCurrency?: boolean;
    userStore?: string;
    pathname: string;
}) {
    const {
        localizationContext: { locales },
    } = useGlobalLocalization();
    const {
        currentPageAlternatives,
        currentLocale,
        shouldDisplayLanguageSwitcher,
    } = usePageLocalization();
    const isBrowser = typeof window !== 'undefined';
    let queryArgs = '';
    if (isBrowser) {
        queryArgs = window.location.search;
    }
    const [_, setCookies] = useCookies(['englander_store_lang']);

    return (
        <ul
            className='nav'
            style={{
                pointerEvents: shouldDisplayLanguageSwitcher(pathname)
                    ? 'auto'
                    : 'none',
            }}
        >
            {Object.values(locales).map((locale: any) => {
                const lang = locale.langCode;
                const currentCountryCode = locale.countryCode;

                // FIXME: Déterminer la monnaie via les attributs sur le pays
                const money = currentCountryCode + 'd';

                const shouldDisplay =
                    (userStore === undefined ||
                        userStore === currentCountryCode) &&
                    locale.localeCode !== currentLocale;

                if (shouldDisplay) {
                    return (
                        <li className='locale' key={locale.localeCode}>
                            <Link
                                to={`${
                                    currentPageAlternatives[locale.localeCode]
                                }${queryArgs}`}
                                hrefLang={locale.bcp47LocaleCode}
                                onClick={() => {
                                    setCookies(
                                        'englander_store_lang',
                                        locale.localeCode,
                                        {
                                            path: '/',
                                        }
                                    );
                                }}
                            >
                                {showCurrency
                                    ? `${money.toUpperCase()} | ${lang.toUpperCase()}`
                                    : `${lang.toUpperCase()}`}
                            </Link>
                        </li>
                    );
                }
            })}
        </ul>
    );
}

export default function SiteLocaleSelectionPopupMenu(props: {
    showCurrency?: boolean;
    direction?: string;
}) {
    const { currentUser } = useCustomerAccount();
    const { currentLocaleDefinition, shouldDisplayLanguageSwitcher } =
        usePageLocalization();
    const lang = currentLocaleDefinition.langCode;
    const country = currentLocaleDefinition.countryCode;
    const money = country + 'd'; // FIXME: Déterminer la monnaie via les attributs sur le pays
    const usaIcon = `data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtMzc1LjE4IDM0My42OGgyMTAuNjJjLTMuMDc0Mi0yMS40OC05LjMzMi00MS45MTgtMTguMzI0LTYwLjgyNGgtMTkyLjN2LTYwLjgyaDE0OC44NWMtMzguMzc1LTM3LjU3OC05MC44OTEtNjAuNzczLTE0OC44NS02MC43NzMtMTE3LjU0IDAtMjEyLjgyIDk1LjI4MS0yMTIuODIgMjEyLjgyczk1LjI3NyAyMTIuODIgMjEyLjgyIDIxMi44MmM1Ny45MzggMCAxMTAuNDQtMjMuMTg0IDE0OC44Mi02MC43NDJoLTE0OC44MnYtNjAuODJoMTkyLjI5YzguOTg4My0xOC45MDYgMTUuMjUtMzkuMzUyIDE4LjMyOC02MC44MjhoLTIxMC42MnptLTUzLjI0MiA5NS44MzItNTAuMTU2LTM2LjQ0OS01MC4xNDUgMzYuNDM4IDE5LjE1Ni01OC45NTctNTAuMTUyLTM2LjQ0OWg2MS45OTZsMTkuMTU2LTU4Ljk2MSAxOS4xNDggNTguOTY1IDYyIDAuMDAzOTA2LTUwLjE0OCAzNi40NDV6Ii8+Cjwvc3ZnPgo=`;

    const [showList, setShowList] = useState<boolean>(true);
    const pathname =
        typeof window !== 'undefined' ? window.location.pathname : '';

    useEffect(() => {
        setShowList(
            currentUser?.store !== 'US' &&
                shouldDisplayLanguageSwitcher(pathname)
        );
    }, [currentUser?.store, pathname, shouldDisplayLanguageSwitcher]);

    return (
        <div className='localeSelection'>
            {country === 'CA' ? (
                <FontAwesomeIcon
                    className='maple-leaf'
                    icon={faCanadianMapleLeaf}
                />
            ) : (
                <img className='usa-icon' src={usaIcon} alt='' />
            )}
            <div className={`currentLocale ${showList ? 'list' : ''}`}>
                <span>
                    {props.showCurrency
                        ? `${money.toUpperCase()} | ${lang.toUpperCase()}`
                        : `${lang.toUpperCase()}`}
                </span>
                {showList && (
                    <Icon
                        className='chevronDown'
                        d='M2.5,0,5,4H0Z'
                        size='6'
                        transform='translate(5 4) rotate(180)'
                    />
                )}
            </div>
            {showList && (
                <div
                    className={
                        props.direction === 'down'
                            ? 'localesContainer'
                            : `localesContainer bottom`
                    }
                >
                    <SiteLocaleSelectionList
                        showCurrency={props.showCurrency}
                        userStore={currentUser?.store}
                        pathname={pathname}
                    />
                </div>
            )}
        </div>
    );
}
